import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import resolveConfig from 'tailwindcss/resolveConfig';

import revTailwindConfig from '../../tailwind.config';

// Atom
import PlayButton from './play-button';

const tailwindConfig = resolveConfig(revTailwindConfig);

const WistiaVideo = ({ id, popOver }) => {
  const isSSR = typeof window === 'undefined';
  const buttonRef = useRef(null);
  const [embedOptions, setEmbedOptions] = useState(null);

  const classHandler = (remove = false) => {
    if (remove) {
      // removing classes
      buttonRef?.current?.classList.remove(
        'opacity-0',
        'pointer-events-none',
        'touch-none'
      );
    } else {
      buttonRef?.current?.classList.add(
        'opacity-0',
        'pointer-events-none',
        'touch-none'
      );
    }
  };

  useLayoutEffect(() => {
    const canPopOver =
      !isSSR &&
      window.innerWidth >
        parseInt(tailwindConfig.theme.screens.mobile.max.replace('px', ''));

    setEmbedOptions(
      [
        'seo=true',
        'videoFoam=true',
        `playerColor=${tailwindConfig.theme.colors.blue.bold.replace('#', '')}`,
        'settingsControl=false',
        'controlsVisibleOnLoad=false',
        'playButton=false',
        ...(popOver && canPopOver
          ? ['popover=true', 'popoverPreventScroll=true']
          : []),
      ].join(' ')
    );
  });

  useEffect(() => {
    if (!isSSR) {
      window._wq = window._wq || [];
      _wq.push({
        id,
        onReady(video) {
          video.bind('play', () => {
            classHandler(false);
          });

          video.bind('end', () => {
            classHandler(true);
          });

          if (popOver) {
            video.bind('pause', () => {
              classHandler(true);
            });
          }

          buttonRef?.current?.removeAttribute('disabled');
          buttonRef?.current?.addEventListener('click', (e) => {
            e.preventDefault();
            video.play();
          });
        },
      });
    }
  });

  return (
    <div className="w-full relative aspect-[16/9]">
      <Helmet>
        <script src="https://fast.wistia.com/assets/external/E-v1.js" async />
      </Helmet>

      {embedOptions !== null && (
        <div
          className={`wistia_embed wistia_async_${id} ${embedOptions} h-full relative w-full`}
        />
      )}

      <PlayButton
        ref={buttonRef}
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        disabled
      />
    </div>
  );
};

WistiaVideo.defaultProps = {
  popOver: false,
};

WistiaVideo.propTypes = {
  id: PropTypes.string.isRequired,
  popOver: PropTypes.bool,
};

export default WistiaVideo;
